import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { finalize, take } from 'rxjs/operators';

import { ApiError } from '../../../../core';
import { AreaSearchOrderBy } from '../../../../home/areas/area-search-orderby';
import { AreaFormSelect } from '../../../../home/areas/components/form-select';
import { AreaFilter } from '../../../../home/areas/filter';
import { AreaSearchHttpService } from '../../../../home/areas/services';
import { areaSituacaoAtiva } from '../../../../home/areas/situacao';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import { ToastService } from '../toast/services/toast.service';

@Component({
  selector: 'sgt-novo-area-multiselect',
  templateUrl: './novo-area-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoAreaMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoAreaMultiselectComponent extends CustomControlValueAccessor<number[]> {
  @Input() idsAreas: number[];
  @Input() somenteAtivas = false;
  @Output() idsAreasChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione as áreas',
    plural: 'Áreas',
    singular: 'Área',
    searchEmptyResultMessage: 'Nenhuma área encontrada',
    showFooter: false
  };

  options: IOption[] = [];
  areas: AreaFormSelect[];

  constructor(
    private toastService: ToastService,
    private areaSearchHttpService: AreaSearchHttpService
  ) {
    super();
  }

  firstOpened(isFirstOpened: boolean): void {
    if (isFirstOpened && this.options.length === 0) {
      this.create();
    }
  }

  private createFilter(): AreaFilter {
    const filter = new AreaFilter();
    if (this.somenteAtivas) {
      filter.situacoes = [areaSituacaoAtiva.id];
    }
    return filter;
  }

  private create() {
    this.options = [];
    const filter = this.createFilter();
    this.definirCarregando(true);

    this.areaSearchHttpService
      .search(filter, AreaSearchOrderBy.Nome, 'asc', -1, -1)
      .pipe(take(1), finalize(() => this.definirCarregando(false)))
      .subscribe(
        (areas) => {
          if (areas) {
            const currentIds = this.value ?? [];
            const a = areas.map((area) => ({
              id: area.id,
              label: area.nome,
              isChecked: currentIds.includes(area.id)
            }));
            this.options = [...this.getShowNullOption(), ...a];
          }
        },
        (error: ApiError) => {
          this.toastService.error(error.message, {
            duration: 5000
          });
        }
      );
  }

  getShowNullOption(): IOption[] {
    return [{ id: 0, label: 'SEM ÁREA' }];
  }

  onSearch() {
    this.idsAreasChange.emit(this.value);
  }

  protected updateValue(newValue: number[] | null): void {
    const ids = newValue ?? [];
    if (ids.length > 0 && this.options.length === 0) {
      this.create();
      return;
    }
    if (this.options.length > 0) {
      this.options.forEach((o) => {
        o.isChecked = ids.includes(o.id);
      });
    }
  }

  onSelectionChange() {
    this.emitChange(this.idsAreas);
    this.markAsTouched();
  }

  private definirCarregando(carregando: boolean): void {
    this.settings = { ...this.settings, isLoading: carregando };
  }

}
